/*
https://splidejs.com/guides/getting-started/
*/

import '@splidejs/splide/css/core';
import Splide from '@splidejs/splide';

document.addEventListener( 'DOMContentLoaded', function () {

    if( document.querySelector( '.main-slider' ) ) {
        var main = new Splide( '.main-slider', {
            type: 'slider',
            rewind: true,
            pagination: false,
            arrows: false,
            start: 0,
            perPage: 1,
            perMove: 1,
            lazyLoad: 'nearby', // load current + neighboring slides
            preloadPages: 1, // preload 1 page ahead of the current
            heightRatio: 0.5, // optional, for consistent height
            autoplay: true,
            interval: 4000,
            pause: false,
        } );
    
        var thumbnails = new Splide( '.thumbnail-slider', {
            fixedWidth : 54,
            fixedHeight: 54,
            rewind: true,
            pagination: false,
            isNavigation: true,
            start: 0,
            perPage: 7,
            lazyLoad: 'nearby', // load current + neighboring slides
            perMove: 1,
            breakpoints : {
                // 600: {
                //     fixedWidth : 60,
                //     fixedHeight: 44,
                // },
            },
        } );
    
        main.sync( thumbnails );
        main.mount();
        thumbnails.mount();
    }
} );

// disable autoplay when out of view
// document.addEventListener( 'DOMContentLoaded', function () {
//   const mainEl = document.querySelector( '.main-slider' );
//   if ( ! mainEl ) {
//     return;
//   }

//   // 2) Initialize main slider WITH autoplay
//   const main = new Splide( '.main-slider', {
//     type         : 'slider',
//     rewind       : true,
//     pagination   : false,
//     arrows       : false,
//     start        : 0,
//     perPage      : 1,
//     perMove      : 1,
//     lazyLoad     : 'nearby',
//     preloadPages : 1,
//     heightRatio  : 0.5,
//     autoplay     : true,    // core Autoplay kicks in automatically
//     interval     : 4000,
//     pauseOnHover : false,
//     pauseOnFocus : false,
//   } ).mount();  

//   // 3) Initialize thumbnail slider
//   const thumbnails = new Splide( '.thumbnail-slider', {
//     fixedWidth   : 54,
//     fixedHeight  : 54,
//     rewind       : true,
//     pagination   : false,
//     isNavigation : true,
//     start        : 0,
//     perPage      : 7,
//     lazyLoad     : 'nearby',
//     perMove      : 1,
//     breakpoints  : {
//       // 600: { fixedWidth: 60, fixedHeight: 44 },
//     },
//   } ).mount();

//   // 4) Sync
//   main.sync( thumbnails );

//   // 5) Grab the built-in Autoplay controller
//   const autoplay = main.Components.Autoplay;

//   // 6) Observe visibility to pause/play
//   const observer = new IntersectionObserver( ( entries ) => {
//     entries.forEach( entry => {
//       if ( entry.isIntersecting ) {
//         autoplay.play();
//       } else {
//         autoplay.pause();
//       }
//     } );
//   }, {
//     root      : null,
//     threshold : 0.5,
//   } );

//   observer.observe( mainEl );
// } );
